module.exports = __webpack_public_path__ + "media/images/emblems/Berg-SG-blazono-3802a6d3b26092e6d096eb64d1d78f43.png";